// Shared payment-method labels — ONE source so the Sales Payment report, the Sales
// list "Mode of Payment" column, and any future surface all read the same wording.
export const METHOD_LABELS: Record<string, string> = {
  bank_transfer: 'Bank transfer', bank: 'Bank', cash: 'Cash', card: 'Card',
  pos: 'POS', cheque: 'Cheque', credit: 'Credit applied', paystack: 'Paystack',
  pod: 'Pay on delivery', mobile_money: 'Mobile money', unknown: 'Unspecified',
}

export function methodLabel(m: string): string {
  return METHOD_LABELS[m] ?? m.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}
